import { Page } from './pages.d';

const page: Page = {
  slug: 'registratie-voltooid',
  title: 'Registratie',
  text: `
    <p>
      test <a href="#">test</a>
    </p>

    <blockquote>
      <p>Hello world!</p>
    </blockquote>
  `,
};

export default page;
